import React from 'react';

declare global {
  interface Window {
    getLanguageFromURL: (() => string) | undefined;
    getCountryFromUrl: (() => string) | undefined;
    // @ts-expect-error: object defintion is not needed for the usage
    dodo?: any;
  }
}

interface PlatformState {
  platform: string;
  isDXF: boolean;
  isLoaded: boolean;
}

interface PlatformContextProps extends PlatformState {
}

interface PlatformContextProviderProps {
}

export enum Platform {
  NONE = 'none',
  DXF = 'dxf',
  GOOSE = 'goose',
}

const defaultState = {
  platform: Platform.NONE,
  isDXF: false,
  isLoaded: false,
};

const getPlatform = (): Platform => {
  let currentPlatform = Platform.NONE;

  if (typeof window.getCountryFromUrl === 'function' && typeof window.getLanguageFromURL === 'function') {
    currentPlatform = Platform.DXF;
  }

  if (typeof (window.dodo ?? false) === 'object') {
    currentPlatform = Platform.GOOSE;
  }

  return currentPlatform;
};

export const PlatformContext = React.createContext<PlatformContextProps>(defaultState);

export const PlatformContextProvider: React.FunctionComponent<React.PropsWithChildren<PlatformContextProviderProps>> = ({ children }) => {
  const [checkTimeout, setCheckTimeout] = React.useState<NodeJS.Timeout>();
  const [platformState, setPlatformState] = React.useState<PlatformState>(defaultState);

  const onPageLoad = () => {
    const currentPlatform = getPlatform();

    if (currentPlatform !== Platform.NONE) {
      setPlatformState({
        ...platformState,
        platform: currentPlatform,
        isDXF: currentPlatform === Platform.DXF,
        isLoaded: true,
      });

      clearTimeout(checkTimeout);
    } else {
      setCheckTimeout(setTimeout(onPageLoad, 1000));
    }
  };

  React.useEffect(() => {
    if (document.readyState === 'complete') {
      onPageLoad();
    } else {
      window.addEventListener('load', onPageLoad, false);
    }

    return () => window.removeEventListener('load', onPageLoad);
  }, []);

  return (
    <PlatformContext.Provider value={platformState}>
      {children}
    </PlatformContext.Provider>
  );
};
